import axios from 'axios';
import { getAuthHeader } from './authService';

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/invoices`;

const headers = () => getAuthHeader();

export type MagazineInvoice = {
  id: number;
  invoice_number: string;
  magazine_booking_id: number | null;
  proposal_id: number | null;
  contract_id: number | null;
  company_id: number | null;
  sales_rep_id: number;
  amount: string | number;
  currency: string;
  status: 'draft' | 'sent' | 'paid' | 'overdue';
  due_date: string | null;
  notes: string | null;
  sent_at: string | null;
  paid_at: string | null;
  createdAt: string;
  updatedAt: string;
  qb_invoice_id?: string | null;
  qb_sync_status?: string | null;
  qb_synced_at?: string | null;
  qb_sync_error?: string | null;
  company?: {
    id: number;
    name: string;
    vat_number?: string | null;
    vat_country_code?: string | null;
    vat_valid?: boolean | null;
    vat_validated_at?: string | null;
    vat_registered_name?: string | null;
    vat_registered_address?: string | null;
  };
  sales_rep?: { id: number; username: string; email: string };
  contract?: { id: number; status: string; signed_at: string | null; proposal_id?: number | null };
  proposal?: {
    id: number;
    status: string;
    line_items?: {
      label: string;
      ad_slot?: {
        label: string;
        issue?: {
          title: string;
          publication?: { name: string };
        };
      };
    }[];
  };
  magazine_booking?: {
    id: number;
    status: string;
    ad_slot?: {
      label: string;
      price?: string | number;
      issue?: {
        title: string;
        publication?: { name: string };
      };
    };
  };
};

export const getInvoices = async (status?: string) => {
  try {
    const params = status ? { status } : {};
    const response = await axios.get(API_URL, { headers: headers(), params });
    return response.data as MagazineInvoice[];
  } catch (error: any) {
    console.log(error.message);
    return [];
  }
};

export const getInvoice = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: headers() });
  return response.data as MagazineInvoice;
};

export const generateInvoiceFromProposal = async (
  proposalId: number,
  options?: { contract_id?: number; notes?: string; due_date?: string }
) => {
  const response = await axios.post(
    `${API_URL}/generate`,
    { proposal_id: proposalId, ...options },
    { headers: headers() }
  );
  return response.data as MagazineInvoice;
};

export const generateInvoice = async (
  magazineBookingId: number,
  options?: { contract_id?: number; notes?: string; due_date?: string }
) => {
  const response = await axios.post(
    `${API_URL}/generate`,
    { magazine_booking_id: magazineBookingId, ...options },
    { headers: headers() }
  );
  return response.data as MagazineInvoice;
};

export const updateInvoice = async (
  id: number,
  data: { notes?: string; due_date?: string; amount?: number }
) => {
  const response = await axios.put(`${API_URL}/${id}`, data, { headers: headers() });
  return response.data as MagazineInvoice;
};

export const updateInvoiceStatus = async (id: number, status: string) => {
  const response = await axios.patch(`${API_URL}/${id}/status`, { status }, { headers: headers() });
  return response.data as MagazineInvoice;
};

export const deleteInvoice = async (id: number) => {
  await axios.delete(`${API_URL}/${id}`, { headers: headers() });
};
